// ServiceList.js
import React, { useEffect, useState } from "react";
import "./ServiceList.css";
import { Col, Row } from "react-bootstrap";
import { ServiceCard,ChildServiceDetails } from "../../index";
import { Paginations, SpinnerLoading } from "../../../../components/index";
import { axiosGet } from "../../../../utils/apis/api";
import { NotFound } from "../../../../components";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";
import { AddService } from "../../../CustomPackages";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "../../../../contexts/TranslationContext";


const ServiceList = ({ errorNotFound, url,setShowHeader }) => {
  const hasUserCookie = Cookies.get("api_key") != null && Cookies.get("api_secret") != null;
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [openService, setOpenService] = useState(false);
  const [openChildDetails, setOpenChildDetails] = useState(false);
  const [fromService, setFromService] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [selectedDates, setSelectedDates] = useState({
    startDate: null,
    endDate: null,
  });

  const [selectedDestination, setSelectedDestination] = useState(null);


  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const resultsPerPage = 9;

  // Check for redirect data after login
    useEffect(() => {
      const checkForRedirect = () => {
        // First check if we have service data in location state (from login redirect)
        if (location.state?.redirectService) {
          const service = location.state.redirectService;
          openServiceForm(service);
          // Clear the state to avoid reopening on refresh
          navigate(location.pathname, { replace: true, state: {} });
          return;
        }
        
        // Then check localStorage as a fallback
        const storedService = localStorage.getItem("redirectService");
        if (storedService) {
          try {
            const service = JSON.parse(storedService);
            openServiceForm(service);
            localStorage.removeItem("redirectService");
          } catch (e) {
            console.error("Error parsing stored service:", e);
            localStorage.removeItem("redirectService");
          }
        }
      };

      checkForRedirect();
    }, [location.state]); 

  const handleServiceClick = (service) => {
    if (!hasUserCookie) {
      // Store service details with timestamp
      const serviceData = {
        ...service,
        redirectTimestamp: new Date().getTime()
      };
      
      localStorage.setItem("redirectService", JSON.stringify(serviceData));
      navigate("/login", { 
        state: { 
          from: location.pathname,
          redirectService: service
        } 
      });
      return;
    }
    
    // User is logged in, open service form directly
    openServiceForm(service);
  };

  // const openServiceForm = (service) => {    
  //   if (!service || !service.name) {
  //     toast.error("Invalid service data");
  //     return;
  //   }
    
  //   setOpenService(true);
  //   setFromService(true);
  //   setSelectedService(service);
  //   setSelectedServiceTypes([service.name]);
  //   setSelectedDates({
  //     startDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
  //   });
  // };

  const openServiceForm = (service) => {
  if (!service || !service.name) {
    toast.error("Invalid service data");
    return;
  }

  setOpenService(true);
  setFromService(true);
  setSelectedService(service);
  setSelectedServiceTypes([service.name]);
  setSelectedDates({
    startDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
  });

  if (service.num_of_childs > 0) {
    setOpenChildDetails(true); 
    setShowHeader(false); 
  } else {
    setOpenService(true); 
  }
};


  const fetchData = async (pageNumber = 1) => {
    try {
      const start = (pageNumber - 1) * resultsPerPage;
      let apiUrl = `${url}/api/method/alltimes.alltimes_travel.doctype.service.service.service?start=${start}&limit=${resultsPerPage}&for_website=true`;

      setIsLoading(true);
      const response = await axiosGet(apiUrl);

      const result = response.result;
      setCurrentPage(result.pagination.metadata.current_page);
      setTotalPages(result.pagination.metadata.total_pages);
      setData(result.items);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      return { data: null, error: error.message };
    }
  };

  const onPageChange = (pageNumber) => {
    fetchData(pageNumber);
  };

  useEffect(() => {
    fetchData(1);
    
    // Clean up any stale redirect data on component mount
    const storedService = localStorage.getItem("redirectService");
    if (storedService) {
      try {
        const serviceData = JSON.parse(storedService);
        // Remove if older than 30 minutes
        if (new Date().getTime() - serviceData.redirectTimestamp > 30 * 60 * 1000) {
          localStorage.removeItem("redirectService");
        }
      } catch (e) {
        localStorage.removeItem("redirectService");
      }
    }
  }, []);
  

  if (isLoading) {
    return (
      <div className="loading-container">
        <SpinnerLoading />
      </div>
    );
  }

  // return (
  //   <>
  //     {openService && selectedService ? (
  //       <AddService
  //         url={url}
  //         quotationId={null}
  //         selectedServices={selectedServiceTypes}
  //         selectedDates={selectedDates}
  //         selectedDestination={null}
  //         fromService={fromService}
  //         onReturn={() => {
  //           setOpenService(false);
  //           setSelectedService(null);
  //           setSelectedServiceTypes([null]);
  //           setSelectedDates({ startDate: null, endDate: null });
  //           toast.success(t("AddedSuccessfully"));
  //           // fetchData(currentPage)
            
  //         }}


  //       />
  //     ) : errorNotFound ? (
  //       <NotFound
  //         errorCode={String(errorNotFound.code)}
  //         errorMessage={String(errorNotFound.message)}
  //         description={String(errorNotFound.description)}
  //       />
  //     ) : (
  //       <div className="PackagesCardList-container">
  //         <Row>
  //           {data.map((item, index) => (
  //             <Col
  //               key={index}
  //               lg={4}
  //               md={6}
  //               sm={12}
  //               className="PackagesCardList-col"
  //             >
  //               <ServiceCard
  //                 pageData={item}
  //                 url={url}
  //                 onOpenService={handleServiceClick}
  //               />
  //             </Col>
  //           ))}
  //         </Row>

  //         <div className="d-flex justify-content-center mt-5">
  //           <Paginations
  //             currentPage={currentPage}
  //             totalPages={totalPages}
  //             onPageChange={onPageChange}
  //           />
  //         </div>

  //             <ToastContainer
  //               position="bottom-right"
  //               hideProgressBar="true"
  //               type="error"
  //             />
  //       </div>
  //     )}
  //   </>
  // );

  return (
  <>
    {openChildDetails && selectedService ? (
      <ChildServiceDetails
        url={url}
        service={selectedService}
        onNext={() => {
          setOpenChildDetails(false);
          setOpenService(true);  
        }}
        onBack={() => {
            setOpenChildDetails(false);
            setShowHeader(true); 
        }}
        setSelectedDestination={setSelectedDestination} 
      />

    ) : openService && selectedService ? (
      <AddService
        url={url}
        quotationId={null}
        selectedServices={selectedServiceTypes}
        selectedDates={selectedDates}
        selectedDestination={selectedDestination}
        fromService={fromService}
        setShowHeader={setShowHeader}
        onReturn={() => {
          setOpenService(false);
          setSelectedService(null);
          setSelectedServiceTypes([null]);
          setSelectedDates({ startDate: null, endDate: null });
          setSelectedDestination(null);
          toast.success(t("AddedSuccessfully"));
          setShowHeader(true);
        }}
      />

    ) : errorNotFound ? (
      <NotFound
        errorCode={String(errorNotFound.code)}
        errorMessage={String(errorNotFound.message)}
        description={String(errorNotFound.description)}
      />

    ) : (
      <div className="PackagesCardList-container">
        <Row>
          {data.map((item, index) => (
            <Col key={index} lg={4} md={6} sm={12}>
              <ServiceCard
                pageData={item}
                url={url}
                onOpenService={handleServiceClick}
              />
            </Col>
          ))}
        </Row>

        <div className="d-flex justify-content-center mt-5">
          <Paginations
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>

        <ToastContainer position="bottom-right" hideProgressBar type="error" />
      </div>
    )}
  </>
);

};

export default ServiceList;